import { createFileRoute } from "@tanstack/react-router";
import { ProductsListPage } from "../../../components/products/ProductsListPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/products/")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: ProductsListPage,
});
